import { map, Observable, of, Subject, takeUntil } from 'rxjs';
import {
  AdjustStateItem,
  BinaryShootingResult,
  CameraSelectionDataForGet,
  CameraSelectionEnumForGet,
  CameraSelectionEnumForSet,
  ComputerState,
  Eyes,
  LockState,
  MovementDirection,
  PhotoCabinControllerService1,
  PhotoCabinControllerService2,
  PhotoCabinInfo,
  PhotoCabinService,
  PhotoCabinState,
  ServiceState,
} from '../photo-booth.service';

function getRandomNumberArray(length: number, min: number = 0, max: number = 9999999) {
  return Array.from(Array(length).keys()).map(() => Rand(min, max));
}

export class StubPhotoCabinService implements PhotoCabinService {
  private mac1 = getRandomNumberArray(6, 0, 250);
  private mac2 = getRandomNumberArray(6, 0, 250);

  private getPhotoCabinInfoArray(): PhotoCabinInfo[] {
    return [
      {
        Address: '192.168.98.26:2801',
        Id: 1,
        MacAddress: this.mac1,
        Name: 'StubPhotoCabin (Блажис)',
        Number: 1,
        State: {
          HostState: {
            ComputerState: ComputerState.On,
            ServiceState: ServiceState.On,
          },
          LockState: LockState.Unlocked,
        },
        Type: 'Инфорсер',
      },
      {
        Address: '192.168.98.26:2801',
        Id: 2,
        MacAddress: this.mac2,
        Name: 'StubPhotoCabin (Спектр v2)',
        Number: 2,
        State: {
          HostState: {
            ComputerState: ComputerState.On,
            ServiceState: ServiceState.On,
          },
          LockState: LockState.Unlocked,
        },
        Type: 'Спектр v2',
      },
    ];
  }

  getPhotoCabinsForMachine(machine: string): Observable<PhotoCabinInfo[]> {
    return of(this.getPhotoCabinInfoArray());
  }

  getPhotoCabinsForClientMachine(): Observable<PhotoCabinInfo[]> {
    return of(this.getPhotoCabinInfoArray());
  }

  getPhotoCabins(): Observable<PhotoCabinInfo[]> {
    return of(this.getPhotoCabinInfoArray());
  }

  getState(id: number): Observable<PhotoCabinState> {
    return of({
      HostState: {
        ComputerState: ComputerState.On,
        ServiceState: ServiceState.On,
      },
      LockState: LockState.Unlocked,
    });
  }

  initiateTurnOn(id: number): Observable<boolean> {
    return of(true);
  }

  initiateTurnOff(id: number): Observable<boolean> {
    return of(true);
  }

  addPhotoCabin(info: PhotoCabinInfo): Observable<boolean> {
    return of(true);
  }

  removePhotoCabin(id: number): Observable<boolean> {
    return of(true);
  }

  changePhotoCabin(info: PhotoCabinInfo): Observable<boolean> {
    return of(true);
  }

  lockPhotoCabin(id: number): Observable<boolean> {
    return of(true);
  }

  touchPhotoCabinLock(id: number): Observable<boolean> {
    return of(true);
  }

  unlockPhotoCabin(id: number): Observable<boolean> {
    return of(true);
  }
}

export class StubPhotoCabinControllerService1 implements PhotoCabinControllerService1 {
  startStreamingURL(id: number): Observable<string> {
    return of('assets/images/sample_animation.gif');
  }

  move(id: number, direction: MovementDirection): Observable<void> {
    return of(undefined);
  }

  shoot(id: number): Observable<BinaryShootingResult> {
    return GetPhoto().pipe(
      map((r) => r),
      map((photo) => ({
        Photo: photo,
        LeftEye: { X: 0, Y: 0 },
        RightEye: { X: 0, Y: 0 },
        ChipPhoto: photo,
        PrintPhoto: photo,
        Quality: {
          Glares: false,
          BadWhiteBalance: false,
          BadFocus: false,
          BadContrast: false,
          BadPose: false,
          BadAngle: false,
          BadEncoding: false,
          IrregularIllumination: false,
        },
      })),
    );
  }

  crop(id: number, left_x: number, left_y: number, right_x: number, right_y: number): Observable<BinaryShootingResult> {
    return this.shoot(id);
  }

  cancel(id: number): Observable<void> {
    return of(undefined);
  }
}

export class StubPhotoCabinControllerService2 implements PhotoCabinControllerService2 {
  open(id: number): Observable<void> {
    return of(undefined);
  }

  close(id: number): Observable<void> {
    return of(undefined);
  }

  startStreamingURL(id: number): Observable<string> {
    return of('assets/images/sample_animation.gif');
  }

  selectCamera(id: number, selection: CameraSelectionEnumForSet): Observable<void> {
    return of(undefined);
  }

  getSelectedCamera(id: number): Observable<CameraSelectionDataForGet> {
    return of({ current: CameraSelectionEnumForGet.Top, isAutoMode: true });
  }

  getAdjustState(id: number): Observable<AdjustStateItem[]> {
    return of([]);
  }

  shoot(id: number, selection: CameraSelectionEnumForGet): Observable<void> {
    return of(undefined);
  }

  findEyes(id: number): Observable<Eyes> {
    return of({
      Left: {
        X: 10,
        Y: 10,
      },
      Right: {
        X: 90,
        Y: 90,
      },
      IsFound: true,
    });
  }

  crop(id: number, left_x: number, left_y: number, right_x: number, right_y: number): Observable<BinaryShootingResult> {
    return GetPhoto().pipe(
      map((r) => r),
      map((photo) => ({
        Photo: photo,
        LeftEye: { X: 10, Y: 10 },
        RightEye: { X: 90, Y: 90 },
        ChipPhoto: photo,
        PrintPhoto: photo,
        Quality: {
          Glares: false,
          BadWhiteBalance: false,
          BadFocus: false,
          BadContrast: false,
          BadPose: false,
          BadAngle: false,
          BadEncoding: false,
          IrregularIllumination: false,
        },
      })),
    );
  }

  getSnapshot(id: number): Observable<string> {
    return GetPhoto().pipe(map((r) => r));
  }

  cancel(id: number): Observable<void> {
    return of(undefined);
  }

  setLight(id: number, on: boolean): Observable<void> {
    return of(undefined);
  }
}

// Фотография
export const GetPhoto: () => Observable<string> = () => {
  const url: string = '../../../assets/images/test-photos-wizard/ex-' + Rand(1, 16) + '.png';
  const xhr: XMLHttpRequest = new XMLHttpRequest();
  const destroy$: Subject<void> = new Subject<void>();
  // Функции отписки
  const destroy: () => void = () => {
    destroy$.next();
    destroy$.complete();
  };
  // Подписчик
  const observable: Observable<string> = new Observable((observer) => {
    xhr.onload = function () {
      const reader: FileReader = new FileReader();
      // Загружено
      reader.onloadend = () => {
        observer.next(reader.result as string);
        observer.complete();
        destroy();
      };
      // Ошибка
      reader.onerror = (e) => {
        observer.error(e);
        destroy();
      };
      // Загрузка данных
      reader.readAsDataURL(xhr.response);
    };
    // Ошибка
    xhr.onerror = (e) => {
      observer.error(e);
      destroy();
    };
    // Запрос
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
  // Вернуть подписчик
  return observable.pipe(takeUntil(destroy$));
};

// Случайное число
const Rand: (min: number, max: number) => number = (min: number, max: number) => Math.floor(min + Math.random() * (max + 1 - min));
